import { createSelector } from '@ngrx/store';
import { selectDistributorsState } from '../../reducers';
import { DistributorsState } from 'src/app/core/store/distributors/distributors.reducer';

/**
 * Get Distributor names by ids
 */
export const distributorNames = createSelector(
  selectDistributorsState,
  (state: DistributorsState) => {
    return {
      distributors: state.distributors,
      invalidDistributorUuids: state.invalidDistributorUuids,
    };
  }
);
